import { Configuration } from '~/core/configuration'

type OptionsCommon = {
  key: string
  tokenUrl: string
  authUrl: string
  scopes: string[]
  authParams?: Record<string, any>
}

type ResponseCommon = {
  key: string
  type: 'oauth2'
  grantType: 'authorization_code'
  tokenUrl: string
  authUrl: string
  redirectUrl: string
  scopes: string[]
  authParams?: Record<string, any>
}

export const Oauth2Common = (options: OptionsCommon): ResponseCommon => {
  return {
    key: options.key,
    type: 'oauth2',
    grantType: 'authorization_code',
    tokenUrl: options.tokenUrl,
    authUrl: options.authUrl,
    scopes: options.scopes,
    redirectUrl: `${Configuration.getBaseUrl()}/redirect`,
    authParams: options.authParams,
  }
}

export type Oauth2CommonType = ReturnType<typeof Oauth2Common>
